import script from "./KPIsDashboard.vue?vue&type=script&setup=true&lang=ts"
export * from "./KPIsDashboard.vue?vue&type=script&setup=true&lang=ts"

import "./KPIsDashboard.vue?vue&type=style&index=0&id=fd853da6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fd853da6"]])

export default __exports__